
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import UiButton from "@/components/button/ui-button.vue";

import InviteManagerIcon from "@/components/icons/paymentV2/InviteManagerIcon.vue";
import InviteResourceIcon from "@/components/icons/paymentV2/InviteResourceIcon.vue";
import { SubscriptionPlansInnerNames } from "@/entities/payment/InnerNames";

@Component({
  components: {
    UiButton,
    InviteResourceIcon,
    InviteManagerIcon,
  },
})
export default class PaymentPlan extends Vue {
  @Prop({ type: String, required: true }) readonly id: String;

  @Prop({ type: String, required: true }) readonly price: String;
  @Prop({ type: String, required: true }) readonly planName: String;
  @Prop({ type: Number, required: true }) readonly totalManager: String;
  @Prop({ type: String, required: true }) readonly description: String;
  @Prop({ type: Object, required: true }) readonly subcription: any;
  @Prop({ type: Array }) readonly allSubscriptionPlans: any;

  @Prop({ type: String }) readonly status: String;

  isCurrent: boolean = false;

  @Watch("subcription",{ immediate: true})
  isCurrentPlan() {
    const currentplanName = this.subcription?.subscription_plan?.inner_name;
    if (currentplanName && currentplanName !== undefined) {
      if (
        (currentplanName.includes("PREMIUM") ||
          currentplanName.includes("ENTERPRISE")) &&
        this.planName === "Premium"
      ) {
        this.isCurrent = true;
      } else if (
        currentplanName === SubscriptionPlansInnerNames.STARTER &&
        this.planName === "Starter"
      ) {
        this.isCurrent = true;
      } else if (
        currentplanName === SubscriptionPlansInnerNames.GROWTH &&
        this.planName === "Growth"
      ) {
        this.isCurrent = true;
      }
    }
     return;
  }

  get isPlanBefore() {
    let selectionIndex = null;

    let planIndex = null;

    this.allSubscriptionPlans?.forEach((plan, index) => {
      if (plan.id === this.subcription?.subscription_plan_id) {
        selectionIndex = index;
      } else if (plan.id === this.id) {
        planIndex = index;
      }
    });

    return (
      selectionIndex !== null &&
      planIndex !== null &&
      planIndex < selectionIndex
    );
  }

  get showPreferred(): boolean {
    return (
      this.subcription?.subscription_plan?.inner_name !==
        SubscriptionPlansInnerNames?.PREMIUM && this.planName === "Premium"
    );
  }
  handleUpgrade(): void {
    this.$emit("handleUpgrade", this.id, this.subcription);
  }
}
